import qs from 'query-string'

import type { Creator } from '@/modules/creators/types'
import { apiClientChatting } from '@/utils/axios'

import type {
  GetNotificationsOptions,
  GetNotificationsResponse,
  UnreadNotificationsCountResponse,
} from '../types'

const getNotifications = ({
  creatorId,
  type,
  anchorId,
}: GetNotificationsOptions): Promise<GetNotificationsResponse> => {
  const queryString = qs.stringify(
    { type, anchorId },
    {
      skipNull: true,
      skipEmptyString: true,
    },
  )

  return apiClientChatting
    .get(`/of-chat/${creatorId}/notifications?${queryString}`)
    .then((res) => res.data)
}

const getUnreadNotificationsCount = (creatorId: Creator['id']) => {
  return apiClientChatting
    .get<UnreadNotificationsCountResponse>(
      `/of-chat/${creatorId}/notifications/count`,
    )
    .then((res) => res.data)
}

export const notificationsService = {
  getNotifications,
  getUnreadNotificationsCount,
}
